import axios from 'axios';
import { API_BASE_URL } from './config';

/**
 * Service für die Verwaltung von Game Server Bestellungen
 */
class GameServerService {
  /**
   * Bestellt einen neuen Game Server
   * @param {Object} orderDetails - Details der Bestellung
   * @param {number} orderDetails.userId - ID des Benutzers
   * @param {number} orderDetails.ram - RAM in GB
   * @param {number} orderDetails.storage - Speicher in GB
   * @param {number} orderDetails.cores - CPU Kerne
   * @param {number} orderDetails.instances - Anzahl der Gameserver Instanzen
   * @param {number} orderDetails.totalPrice - Gesamtpreis der Bestellung
   * @returns {Promise} - Promise mit dem Ergebnis der Bestellung
   */
  orderGameServer(orderDetails) {
    const payload = {
      serviceType: 'game-server',
      configuration: {
        ram: orderDetails.ram,
        storage: orderDetails.storage,
        cores: orderDetails.cores,
        instances: orderDetails.instances,
        ...(orderDetails.priceInfo ? { priceInfo: orderDetails.priceInfo } : {})
      },
      totalPrice: orderDetails.totalPrice
    };

    return axios.post(`${API_BASE_URL}/iaas-service/order`, payload, { withCredentials: true });
  }

  /**
   * Holt alle Game Server eines Benutzers
   * @param {number} userId - ID des Benutzers
   * @returns {Promise} - Promise mit den Diensten des Benutzers
   */
  getUserGameServers(userId) {
    const params = userId ? { userId } : {};
    return axios.get(`${API_BASE_URL}/iaas-service/`, { params });
  }

  /**
   * Holt alle aktiven Game Server eines Benutzers
   * @param {number} userId - ID des Benutzers
   * @returns {Promise} - Promise mit den aktiven Diensten des Benutzers
   */
  getActiveUserGameServers(userId) {
    const params = userId ? { userId } : {};
    return axios.get(`${API_BASE_URL}/iaas-service/active`, { params });
  }

  /**
   * Berechnet den Preis basierend auf den ausgewählten Ressourcen
   * @param {number} ram - RAM in GB
   * @param {number} storage - Speicher in GB
   * @param {number} cores - CPU Kerne
   * @param {number} instances - Anzahl der Gameserver Instanzen
   * @returns {number} - Berechneter Preis
   */
  calculatePrice(ram, storage, cores, instances = 1) {
    // Beispielhafte Preisberechnung
    const ramPrice = ram * 1.25; // 1,25 € pro GB RAM
    const storagePrice = storage * 0.1; // 0,10€ pro GB Speicher
    const coresPrice = cores * 1; // 1€ pro CPU Kern
    const instancesPrice = instances * 1.5; // 1,5 € pro Instanz
    
    return (ramPrice + storagePrice + coresPrice + instancesPrice);
  }
}

export default new GameServerService();
